import { HEADERS_NAMES, API_ERRORS } from "~/utils/constants";
import { generateUUID } from "~/utils/generateUUID";
import { useAuthStorage } from "~/composables/useAuthStorage";

const getAuthHeaders = () => {
  const { getToken, getClientUUID } = useAuthStorage();
  const headers = {};

  const token = getToken();
  const clientUUID = getClientUUID();

  if (token) headers[HEADERS_NAMES.authToken] = token;
  if (clientUUID) headers[HEADERS_NAMES.clientUUID] = clientUUID;

  return headers;
};

const REFRESH_TOKEN_RESPONSE_CODES = [
  API_ERRORS.API_TOKEN_FAILED,
  API_ERRORS.API_TOKEN_MAX_USES_EXCEEDED,
  API_ERRORS.API_TOKEN_VALIDITY_EXCEEDED,
];

export const getApiToken = async () => {
  const { public: config } = useRuntimeConfig();
  const clientUUID = generateUUID();

  try {
    const response = await $fetch("/api/token/create", {
      baseURL: config.API_DOMAIN,
      method: "POST",
      credentials: "include",
      headers: {
        [HEADERS_NAMES.clientUUID]: clientUUID,
      },
      body: {
        api_key: config.API_KEY,
      },
    });

    return {
      token: response?.token || "",
      clientUUID: clientUUID,
    };
  } catch (e) {
    return null;
  }
};

export const refreshApiToken = async () => {
  const { public: config } = useRuntimeConfig();

  try {
    const response = await $fetch("/api/token/refresh", {
      baseURL: config.API_DOMAIN,
      method: "GET",
      credentials: "include",
      headers: getAuthHeaders(),
    });

    // API always returns HTTP 200 — check response body for error codes
    if (
      response?.statuscode === 500 ||
      REFRESH_TOKEN_RESPONSE_CODES.includes(response?.code)
    ) {
      const error = new Error(response?.description || "Token refresh failed");
      error.code = response?.code;
      throw error;
    }

    if (!response?.token) {
      throw new Error("No token in refresh response");
    }

    return { token: response.token, validity: response.validity || "" };
  } catch (e) {
    return null;
  }
};
